(function ($) {
  $(document).ready(function ($) {
    $('.shogun-form-box-submit').click(function (event) {
      // Prevent the default form submission
      event.preventDefault();

      var _learnq = _learnq || [];

      // Grab the email input value
      var email = $('.shogun-form-box input[type="email"]').val();

      // Validate the email
      var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (emailRegex.test(email)) {
        // Get the current URL
        var currentUrl = window.location.href;

        // Check if the URL already has query parameters
        var separator = currentUrl.includes('?') ? '&' : '?';

        // Create the new URL
        var newUrl = currentUrl + separator + 'utm_email=' + email;

        _learnq.push([
          'identify',
          {
            $email: email,
          },
        ]);
        klaviyo.push([
          'identify',
          {
            // Change the line below to dynamically print the user's email.
            $email: email,
          },
        ]);
        // Update the URL using window.history.replaceState
        window.history.replaceState({}, '', newUrl);
        //window.location.href = newUrl;
      } else {
        // Handle invalid email
        console.log('Needs to be a valid email.');
      }
    });
  });
})(jQuery);
